<template>
    <div>
        <div class="button-panel">
            <van-button type="info" class="button" @click="scan">扫码验票</van-button>
        </div>
        <div class="text-info">
            验票须知：点击【扫码验票】按钮扫描电子票二维码，系统自动验证后结果将显示在界面上。
        </div>
        <div v-if="scan_result==1">
            <div class="success-box">
                <van-icon class="result-icon" name="passed" />
                <div class="result-text">验票成功</div>
            </div>
            <div class="success-content">
                <div class="item">
                    <span class="label">电子票据</span>
                    <span class="content">{{ticket_string}}</span>
                </div>
                <div class="item">
                    <span class="label">凭证编码</span>
                    <span class="content">{{info.code}}</span>
                </div>
                <div class="item">
                    <span class="label">产品名称</span>
                    <span class="content">{{info.product_name}}</span>
                </div>
                <div class="item">
                    <span class="label">付款金额</span>
                    <span class="content">{{info.price}}</span>
                </div>
                <div class="item">
                    <span class="label">购买时间</span>
                    <span class="content">{{moment.unix(info.create_time).format('YYYY-MM-DD HH:mm:ss')}}</span>
                </div>
                <div class="item">
                    <span class="label">客户名称</span>
                    <span class="content">{{info.nick_name}}</span>
                </div>
            </div>

        </div>
        <div v-if="scan_result==2">
            <div class="fail-box">
                <van-icon class="result-icon" name="close" />
                <div class="result-text">验票失败</div>
            </div>
            <div class="item">
                <span class="label">电子票据</span>
                <span class="content">{{ticket_string}}</span>
            </div>
            <div class="fail-content">失败原因：{{info.fail_memo}}</div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import wx from 'weixin-js-sdk';

    export default {
        name: "CheckTicket",
        data(){
            return {
                moment:this.$moment,
                ticket_string:'',
                scan_result:0,  //扫码验票结果值：1成功，2失败
                info:{},
            }
        },
        methods:{
            ...mapActions([
                'WeixinSdkConfig',
                'CheckETicket',
            ]),
            wx_config_ready(){
                //梅唐四季模式mode=1
                let mode=1,url=encodeURIComponent(window.location.href);
                this.WeixinSdkConfig({mode,url}).then(res=>{
                    if(res.status==0){
                        let data = res.responseObject;
                        // console.log('获取到微信config-data',data);
                        let appId = data.appId;
                        let timestamp = data.timestamp.toString();
                        let nonceStr = data.nonceStr;
                        let signature = data.signature;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: appId, // 必填，公众号的唯一标识
                            timestamp: timestamp, // 必填，生成签名的时间戳
                            nonceStr: nonceStr, // 必填，生成签名的随机串
                            signature: signature,// 必填，签名
                            jsApiList: [
                                'scanQRCode',
                            ] // 必填，需要使用的JS接口列表
                        });
                    }
                })
            },
            scan(){
                const that=this;
                wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                        let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                        // console.log('条码内容：',result);
                        that.ticket_string=result;
                        let p={
                            'qr':result,
                            'uid':'1001'
                        };
                        that.CheckETicket(p).then(res=>{
                            if(res.status>0){
                                //失败
                                that.scan_result=2;
                                that.info.fail_memo=res.msg;
                            }else{
                                //成功
                                that.scan_result=1;
                                that.info=res.responseObject;
                            }
                        })
                    }
                });
            }
        },
        mounted() {
            this.wx_config_ready();
        }
    }
</script>

<style lang="scss" scoped>
    .button-panel{
        text-align: center;
        padding-top: 20px;
        .button{
            width: 80%;
            border-radius: 20px;
        }
    }
    .text-info{
        text-align: left;
        padding: 14px;
        font-size: 12px;
        color: #999999;
    }
    .item{
        padding-left: 14px;
        padding-top: 8px;
        text-align: left;
    }
    .label{
        font-size: 14px;
        color: #999999;
    }
    .content{
        padding-left: 6px;
        font-size: 14px;
        color: #666666;
    }

    .success-box{
        text-align: center;
        padding-top: 14px;
        color: #2dd36f;
    }
    .result-icon{
        font-size: 48px;
    }
    .result-text{
        font-size: 24px;
    }
    .fail-box{
        text-align: center;
        padding-t: 14px;
        color: #eb445a;
    }
    .fail-content{
        padding-left: 14px;
        padding-top: 8px;
        text-align: left;
        color: #666666;
        font-size: 14px;
    }

    .memo{
        font-size: 12px;
        padding: 14px;
        color: #999999;
    }

    .success-content{
        font-size: 12px;
    }
</style>
